import Spinner from "react-bootstrap/Spinner";

const Loading = () => {
    return (
        <>
            <div
                style={{
                    display: "flex",
                    height: "100vh",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Spinner animation="grow" variant="success" size="lg" />
            </div>
        </>
    );
};

export default Loading;
